module.exports = __webpack_public_path__ + "img/icon_alarm_bag_hover.74031c8a.png";